<template>
  <div class="searchBar">
    <a-row>
      <SearchBarItem :span="6" label="姓名：">
        <a-input v-model="searchData.username" placeholder="请输入姓名" allow-clear></a-input>
      </SearchBarItem>

      <SearchBarItem :span="6" label="手机号：">
        <a-input v-model="searchData.phone" placeholder="请输入手机号" allow-clear></a-input>
      </SearchBarItem>

      <SearchBarItem :span="6" label="状态：">
        <a-select style="width: 100%" v-model="searchData.status" placeholder="请选择状态" allow-clear>
          <a-select-option value="">全部</a-select-option>
          <a-select-option v-for="(v, k) in CHILD_ACCOUNT_STATUS" :key="k" :value="k">{{ v }}</a-select-option>
        </a-select>
      </SearchBarItem>

      <SearchBarItem :span="6" label="所属事业部：">
        <a-select
          style="width: 100%"
          v-model="searchData.bussdepid"
          :options="bussDeptList"
          placeholder="请选择事业部"
          allow-clear
        ></a-select>
      </SearchBarItem>

      <SearchBarItem :span="6" label="申请时间：">
        <a-range-picker
          style="width: 100%"
          v-model="applyTime"
          :placeholder="['请选择开始时间', '请选择结束时间']"
          valueFormat="x"
          :show-time="{ format: 'HH:mm' }"
          allow-clear
        ></a-range-picker>
      </SearchBarItem>

      <a-col :span="4" style="float: right">
        <a-button style="margin-right: 24px" type="primary" @click="query">查询</a-button>
        <a-button @click="reset">重置</a-button>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import SearchBarItem from './components/searchBar/item.vue'
import { depList } from '@/api/common'

export const CHILD_ACCOUNT_STATUS = {
  1: '可用',
  2: '不可用',
}

export default {
  name: 'ChildManageSearchBar',
  components: {
    SearchBarItem,
  },
  data() {
    return {
      CHILD_ACCOUNT_STATUS,
      applyTime: [],
      searchData: this.initialQuery(),
      bussDeptList: [],
    }
  },
  computed: {
    params() {
      const [start, end] = this.applyTime

      const obj = {
        ...this.searchData,
      }

      if (start) {
        obj.cStartTimeStamp = +start
      }

      if (end) {
        obj.cEndTimeStamp = +end
      }

      return obj
    },
  },
  created() {
    this.getDeptList()
  },
  methods: {
    initialQuery() {
      return {
        username: undefined,
        phone: undefined,
        status: '',
        bussdepId: '',
      }
    },
    query() {
      this.$emit('query', this.params)
    },
    reset() {
      this.searchData = this.initialQuery()
      this.applyTime = []

      this.$emit('query', this.params)
    },
    async getDeptList() {
      try {
        const { code, result } = await depList()
        if (code == 1) {
          const validRes = result
            .map((item) => ({ label: item.name, value: item.id }))
            .filter((item) => (window.environment == 'bz' ? item.name == '博众事业部' : true))

          this.bussDeptList = [{ label: '全部', value: '' }].concat(validRes)
        }
      } catch (e) {}
    },
  },
}
</script>

<style lang="less" scoped>
.searchBar {
  padding: 20px;
}
</style>